import React from "react";
import { Container, Typography, Link, Paper } from "@mui/material";

export const PrivacyPolicyPage = () => {
  return (
    <Container maxWidth="md" component="main">
      <Paper elevation={3} sx={{ p: 4, mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Privacy Policy for Rotten Egg
        </Typography>
        <Typography variant="body1" paragraph>
          Last updated: 28/04/2024
        </Typography>
        
        <Typography variant="h6" gutterBottom>
          Information Collection And Use
        </Typography>
        <Typography variant="body1" paragraph>
          Our game prioritizes user privacy and limits the collection of personally identifiable information to only what is necessary for providing essential services and functionalities. When using our game, we may request you to provide us with certain personally identifiable information. However, we do not collect any unnecessary or excessive data that is not directly relevant to the intended purpose of the game.

          The only piece of personally identifiable information we may ask for is a nickname or username for multiplayer functionality. This nickname is used solely within the game environment and does not require any additional personal details such as email addresses or full names. We do not collect any other personal information unless explicitly provided by the user for specific functionalities within the game.

          It's important to note that we do not gather any sensitive personal information such as financial details, government-issued identification numbers, or physical addresses. Additionally, we do not employ any tracking mechanisms to monitor user behavior outside of our game environment.

          By providing a nickname or username for multiplayer functionality, users understand and consent to the collection of this limited information solely for the purpose of enhancing their gaming experience. Users are encouraged to choose a nickname that does not reveal any personally identifiable information to protect their privacy.

          Rest assured, we are committed to maintaining the confidentiality and security of any personally identifiable information collected, and we do not share, sell, or disclose this information to third parties without explicit consent, except as required by law or in compliance with legal obligations.

          If you have any concerns regarding the collection or use of your information, or if you wish to inquire about the data we may have collected, please feel free to contact us at rc@cenedex.com.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Log Data
        </Typography>
        <Typography variant="body1" paragraph>
          We want to inform you that whenever you use our game, in the event of an error occurring within the game, we collect data and information on your device for error handling and debugging purposes. This collected data is referred to as Log Data.

          The Log Data we collect may include information such as your device's Internet Protocol ("IP") address, device name, operating system version, configuration of the game when utilizing our game, the time and date of your use of the game, and other statistics relevant to the performance of the game.

          The primary purpose of collecting this Log Data is to facilitate the identification and resolution of technical issues, errors, or bugs that may occur during your gameplay experience. By logging IP addresses and nicknames associated with the error, we can effectively diagnose and address any issues that may impact the functionality or enjoyment of the game.

          It's important to note that this Log Data is used solely for internal purposes related to improving the quality and stability of our game. We do not use this data for any other purposes, and we do not share, sell, or disclose it to third parties unless required by law or as necessary to comply with legal obligations.

          We are committed to safeguarding the privacy and security of your data, including any Log Data collected during your use of our game. If you have any questions or concerns regarding the collection or use of Log Data, please feel free to contact us using the information provided in the "Contact Us" section of this privacy policy.
        </Typography>

        {/* ... more sections of the privacy policy ... */}

        <Typography variant="h6" gutterBottom>
          Changes To This Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us.
        </Typography>
        
        {/* Example of a link to contact */}
        <Link href="mailto:rc@cenedex.com" variant="body1">
          rc@cenedex.com
        </Link>
      </Paper>
    </Container>
  );
};
